module.exports = __webpack_public_path__ + "static/media/ico-star-half.a61ea810.svg";